import React from "react";
import { motion } from "framer-motion";
import "./Topbar.css";
import { FaTwitter, FaFacebookF, FaLinkedinIn, FaYoutube, FaEnvelope, FaInstagram, FaWhatsapp } from "react-icons/fa";

const Topbar = () => {
  return (
    <motion.div 
      className="topbar"
      initial={{ y: -50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <div className="topbar-left">
<a href="https://wa.me/9972812736" target="_blank" rel="noopener noreferrer"><FaWhatsapp /></a>        
<a href="https://www.facebook.com/share/1AzmTpPntq/" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
        <a href="https://www.linkedin.com/company/sreenathji-enterprises/" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
        <a href="https://www.instagram.com/sreenathji_enterprises?utm_source=qr&igsh=ZXN4b2xob2dvMGM5" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
      </div>

      <div className="topbar-right">
        <a href="mailto:admin@sreenathji.com" className="email">
  <FaEnvelope /> admin@sreenathji.com
</a>

        <a href="/brochure.pdf" className="brochure-link">Download Brochure</a>
      </div>
    </motion.div>
  );
};

export default Topbar;
